@let p = project();
<pai-anchor-card
  [image]="p.image"
  [imageOptions]="imgOpts"
  [title]="p.title"
  [text]="p.excerpt"
  [target]="target()"
  [preserveQueryParams]="true"
  ctaKey="CardProject.ReadMore"
  ctaIcon="chevron_right"
/>
